import { memo } from 'react'

import {
  type AllFundSymbol,
  isFund,
  type ProductSymbol,
  type SimulatedFundSymbol,
  type VaultSymbol,
} from '@repo/common/queries/products'

import { FundAmount } from './FundAmount'
import { VaultAmount } from './VaultAmount'

export const ProductAmount = memo<{
  symbol: ProductSymbol | SimulatedFundSymbol
}>(function ProductAmount({ symbol }) {
  if (isFund(symbol)) {
    return <FundAmount symbol={symbol as AllFundSymbol} />
  }
  return <VaultAmount symbol={symbol as VaultSymbol} />
})
